export class PairVwap {
  public pairName: string;
  public minRatePrecision: number;
  public sptRatePrecision: number;
  public fwdRatePrecision: number;
  public pipIndex: number;
  public useOzs: boolean;
  public isFwdTracked: boolean = false;

  public amount: string;
  public rate: string;
  public invertRate: string;
  public intent: string;
  public exactAmount: string;
  public tenor: string;

  constructor(
    pairName: string,
    minRatePrecision: number,
    sptRatePrecision: number,
    fwdRatePrecision: number,
    pipIndex: number,
    useOzs: boolean,
    tenor: string = "Spot",
  ) {
    this.pairName = pairName;
    this.minRatePrecision = minRatePrecision;
    this.sptRatePrecision = sptRatePrecision;
    this.fwdRatePrecision = fwdRatePrecision;
    this.pipIndex = pipIndex;
    this.useOzs = useOzs;
    this.tenor = tenor;
  }
}
